module.exports = __webpack_public_path__ + "static/media/final-hole-in-one-token.8cf26125.png";